import React from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionTab,
  BreakPointItem,
  BREAKPOINTS,
  Tooltip
} from '@tfecom-thermofisher/react-komodo-design';

import { Button, Visible, Message } from 'src/core/components';
import { Summary } from 'src/components/OligoDNA/components';

import './FooterBar.style.scss';

const FooterBar = ({
  footerNext,
  footerPrevious,
  onPrevious,
  onNext,
  showFooterPrevious,
  showOrderSummaryMobile,
  canContinue,
  getContinueBtnTooltipMessage
}) => (
  <div className="footer-bar-container">
    <div className="bar" />
    <Visible when={showOrderSummaryMobile}>
      <BreakPointItem max={BREAKPOINTS.md} includeMax>
        <Accordion>
          <AccordionTab openOnLoad={false} labelText="View order summary">
            <Summary />
          </AccordionTab>
        </Accordion>
      </BreakPointItem>
    </Visible>
    <div className="buttonContainer">
      <Visible when={showFooterPrevious}>
        <Button type="outline" label={footerPrevious} onClick={onPrevious} />
      </Visible>
      <Tooltip
        tooltipContent={(
          <div className="buttonContainer__tooltip">
            <Message message={getContinueBtnTooltipMessage()} />
          </div>
        )}
        disabled={canContinue}
        placement="top"
        trigger="mouseenter"
      >
        <div>
          <Button
            type="primary"
            label={footerNext}
            onClick={onNext}
            disabled={!canContinue}
          />
        </div>
      </Tooltip>
    </div>
  </div>
);

FooterBar.propTypes = {
  footerNext: PropTypes.object,
  footerPrevious: PropTypes.object,
  onPrevious: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  showFooterPrevious: PropTypes.bool.isRequired,
  showOrderSummaryMobile: PropTypes.bool.isRequired,
  canContinue: PropTypes.bool.isRequired,
  getContinueBtnTooltipMessage: PropTypes.func.isRequired
};

export default FooterBar;
